/**
 * Grouped bar chart — one group per site, bars for each subscale (S1–S6).
 */

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import { SUBSCALE_META } from '@/lib/dashboard/types';
import type { SiteBarDatum } from '@/lib/dashboard/aggregations';

export function SiteBarChart({ data }: { data: SiteBarDatum[] }) {
  if (data.length === 0) {
    return (
      <div className="rounded-xl border bg-card p-5 text-center text-sm text-muted-foreground">
        No data to chart.
      </div>
    );
  }

  return (
    <div className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-muted-foreground uppercase tracking-wide">
        Subscale Scores by Site
      </h3>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} barCategoryGap="15%">
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="siteName"
            tick={{ fontSize: 11 }}
            interval={0}
            angle={-15}
            textAnchor="end"
            height={60}
          />
          <YAxis domain={[0, 7]} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <ReferenceLine y={5} stroke="#8AB74A" strokeDasharray="4 4" label={{ value: 'Good', fill: '#8AB74A', fontSize: 11 }} />
          {SUBSCALE_META.map((s) => (
            <Bar key={s.id} dataKey={s.id} name={s.name} fill={s.color} radius={[3, 3, 0, 0]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
